interface FilterTags {
  cmsName: string;
  contentful_id: string;
  displayLabel: string;
}

interface FilterCategories extends FilterTags {
  filterTags: FilterTags[];
}

const createFilterState = ({
  filterCategories,
  isStandard,
  province,
}: {
  isStandard: boolean;
  province: string;
  filterCategories: FilterCategories[];
}) => {
  const filterState = Object.entries(filterCategories).reduce(
    (acc, [_, value]) => {
      const tags = value.filterTags;
      const filterTags = tags.reduce((filterTagsResult, filterTag) => {
        if (
          isStandard
          && ((filterTag.cmsName === 'standard-carrier-shaw'
            && !['AB', 'BC'].includes(province))
            || (filterTag.cmsName === 'standard-carrier-freedom'
              && !['AB', 'BC', 'ON'].includes(province)))
        ) {
          return filterTagsResult;
        }
        filterTagsResult[filterTag.cmsName] = false;
        return filterTagsResult;
      }, {});
      acc[value.cmsName] = filterTags;

      return acc;
    },
    {},
  );
  return filterState;
};

export default createFilterState;
